import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  "class": "fcon_trigger_view"
};
var _hoisted_2 = {
  "class": "fc_trigger_logo"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  "class": "fc_trigger_titles"
};
var _hoisted_5 = {
  "class": "fc_trigger_name"
};
var _hoisted_6 = {
  "class": "fc_trigger_actions"
};
var _hoisted_7 = {
  "class": "fcon_trigger_details"
};
var _hoisted_8 = {
  key: 0,
  "class": "fcon_trigger_editor"
};
var _hoisted_9 = {
  key: 0
};
var _hoisted_10 = {
  "class": "el-form-item__content"
};
var _hoisted_11 = {
  style: {
    "display": "block",
    "margin-top": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tag = _resolveComponent("el-tag");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_form_builder = _resolveComponent("form-builder");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_checkbox = _resolveComponent("el-checkbox");
  var _component_el_button = _resolveComponent("el-button");
  var _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $props.trigger.is_open = !$props.trigger.is_open;
    }),
    "class": "fcon_provider_info"
  }, [_createElementVNode("div", _hoisted_2, [$props.provider_info ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $props.provider_info.logo
  }, null, 8 /* PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($props.trigger.title), 1 /* TEXT */)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_tag, {
    size: "mini"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString($props.trigger.status), 1 /* TEXT */)];
    }),
    _: 1 /* STABLE */
  }), _cache[6] || (_cache[6] = _createElementVNode("span", {
    "class": "fc_item_open"
  }, [_createElementVNode("i", {
    "class": "el-icon el-icon-arrow-down"
  })], -1 /* HOISTED */))])]), _createElementVNode("div", _hoisted_7, [$props.trigger.is_open ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[10] || (_cache[10] = _createElementVNode("h3", null, "Select Integration Event", -1 /* HOISTED */)), _createVNode(_component_el_select, {
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $options.triggerEventChanged();
    }),
    placeholder: "Select Integration Event",
    modelValue: $props.trigger.trigger_name,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $props.trigger.trigger_name = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.provider_info.triggers, function (triggerItem, triggerName) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: triggerName,
          value: triggerName,
          label: triggerItem.title
        }, null, 8 /* PROPS */, ["value", "label"]);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]), $props.trigger.trigger_name ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_form_builder, {
    fields: $data.settings_fields,
    "form-data": $props.trigger.settings
  }, null, 8 /* PROPS */, ["fields", "form-data"]), _createElementVNode("div", _hoisted_10, [_cache[7] || (_cache[7] = _createElementVNode("label", null, "Internal Label", -1 /* HOISTED */)), _createVNode(_component_el_input, {
    placeholder: "Internal Label",
    modelValue: $props.trigger.title,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $props.trigger.title = $event;
    })
  }, null, 8 /* PROPS */, ["modelValue"])]), _createVNode(_component_el_checkbox, {
    modelValue: $props.trigger.status,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $props.trigger.status = $event;
    }),
    "true-label": "published",
    "false-label": "draft"
  }, {
    "default": _withCtx(function () {
      return _cache[8] || (_cache[8] = [_createTextVNode("Activate this trigger")]);
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $options.emitSave();
    }),
    size: "small",
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return _cache[9] || (_cache[9] = [_createTextVNode("Save Trigger")]);
    }),
    _: 1 /* STABLE */
  })])])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true)])])), [[_directive_loading, $data.loading]]);
}